import MUIFormControl, { FormControlProps } from '@mui/material/FormControl';
import MUIFormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import MUIFormLabel, { FormLabelProps } from '@mui/material/FormLabel';

export function FormControl(props: FormControlProps) {
	return <MUIFormControl {...props} />;
}

export function FormControlLabel(props: FormControlLabelProps & { removeLeftMargin?: boolean; removeMarginRight?: boolean }) {
	const { removeLeftMargin, removeMarginRight, sx, ...rest } = props;
	return (
		<MUIFormControlLabel
			{...rest}
			sx={{
				...sx,
				...(removeLeftMargin ? { marginLeft: 0 } : {}),
				...(removeMarginRight ? { marginRight: 0 } : {})
			}}
		/>
	);
}

export const FormLabel = (props: FormLabelProps) => {
	return <MUIFormLabel {...props} />;
};
